import lang from '../../lib/language';

export const WEEK52_GAINERS_AND_LOSERS_SYMBOL_NAME_LIMIT = 12;
export const WEEK52_GAINERS_AND_LOSERS_SYMBOL_NAME_NOT_STANDART_LIMIT = 8;
export const WEEK52_GAINERS_AND_LOSERS_SYMBOL_NAME_MOB_LIMIT = 10;
export const WEEK52_GAINERS_AND_LOSERS_TABLE_HEADERS = [
  lang.commonEpicMoversSymbolName(),
  lang.commonLastPrice(),
  lang.commonEpicMoversDaily52Wk(),
];

/** History key NavButtons stores the open tab under, so going back restores it. */
export const WEEK_52_HIGH_LOW_TAB_STATE_KEY = 'week52HighLowTab';
